import { render, staticRenderFns } from "./ChipMenu.vue?vue&type=template&id=c521b518&"
import script from "./ChipMenu.vue?vue&type=script&lang=js&"
export * from "./ChipMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports